import { Card, CardContent, CardHeader, Skeleton } from '@mui/material';
import { EmptyContent } from 'src/components/empty-content';
import { Chart } from 'src/components/chart';
import { ChartOptions } from 'src/components/chart/types';

type PredictionChartCardProps = {
  title: string;
  subheader: string;
  loading: boolean;
  hasData: boolean;
  chartType: 'line' | 'bar';
  series: any;
  options: ChartOptions;
  emptyTitle: string;
};

export const PredictionChartCard = ({
  title,
  subheader,
  loading,
  hasData,
  chartType,
  series,
  options,
  emptyTitle,
}: PredictionChartCardProps) => {
  if (loading) {
    return (
      <Card sx={{ mb: 2 }}>
        <CardHeader title={title} subheader={subheader} />
        <CardContent>
          <Skeleton height={360} width="100%" />
        </CardContent>
      </Card>
    );
  }

  if (!hasData) {
    return (
      <Card sx={{ mb: 2 }}>
        <CardHeader title={title} subheader={subheader} />
        <CardContent>
          <EmptyContent title={emptyTitle} />
        </CardContent>
      </Card>
    );
  }

  return (
    <Card sx={{ mb: 2 }}>
      <CardHeader title={title} subheader={subheader} />
      <CardContent>
        <Chart type={chartType} series={series} options={options} height={360} />
      </CardContent>
    </Card>
  );
};
